enum AlertType {
  Error = 'error',
  Destructive = 'destructive',
  Confirm = 'confirm',
}

export default AlertType;
